import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthState, CartItem } from './types';

interface AppStore extends AuthState {
  cart: CartItem[];
  discountPct: number;
  setAuth: (auth: Partial<AuthState>) => void;
  clearAuth: () => void;
  setCart: (items: CartItem[]) => void;
  setDiscount: (pct: number) => void;
}

export const useAppStore = create<AppStore>()(
  persist(
    (set) => ({
      token: null,
      userId: null,
      role: null,
      firstName: null,
      photoUrl: null,
      telegramId: null,
      authAdminHint: false,
      authFullAdminHint: false,
      authPlatformOwnerHint: false,
      authCrmScope: 'none' as const,
      authCrmAccess: false,
      cart: [],
      discountPct: 0,
      setAuth: (auth) => set((s) => ({ ...s, ...auth })),
      clearAuth: () =>
        set({
          token: null,
          userId: null,
          role: null,
          firstName: null,
          discountPct: 0,
          photoUrl: null,
          telegramId: null,
          authAdminHint: false,
          authFullAdminHint: false,
          authPlatformOwnerHint: false,
          authCrmScope: 'none',
          authCrmAccess: false,
        }),
      setCart: (items) => set({ cart: items }),
      setDiscount: (pct) => set({ discountPct: pct }),
    }),
    {
      name: 'onviz-store-v202605-owner-recovery',
      partialize: (s) => ({
        token: s.token,
        userId: s.userId,
        role: s.role,
        firstName: s.firstName,
        discountPct: s.discountPct,
        photoUrl: s.photoUrl,
        telegramId: s.telegramId,
        authAdminHint: s.authAdminHint,
        authFullAdminHint: s.authFullAdminHint,
        authPlatformOwnerHint: s.authPlatformOwnerHint,
        authCrmScope: s.authCrmScope,
        authCrmAccess: s.authCrmAccess,
      }),
    }
  )
);
